import { getKanbanWorks } from '@/utils/request'

function getDefaultState () {
  return {
    statisticsFilterType: null,
    filters: {
      text: null,
      consultantIds: [],
      technicianIds: [],
      teamIds: [],
      estimateDeliveryTime: []
    },
    beginWork: null,
    middleWorks: [],
    endWorks: [],
    loaded: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  RESET_WORK_LIST () {
    state.beginWork.workList = []
    for (const column of state.middleWorks) {
      for (const item of column) {
        item.workList = []
      }
    }
    for (const column of state.endWorks) {
      column.workList = []
    }
  }
}

const actions = {
  getKanbanWorks ({ commit, state }, queryType) {
    return new Promise((resolve, reject) => {
      getKanbanWorks(queryType).then(response => {
        state.beginWork = response.data.beginWork
        state.middleWorks = response.data.middleWorks
        state.endWorks = response.data.endWorks
        state.loaded = true
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
